export default "__VITE_PUBLIC_ASSET__bfad0049__"